var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    _vm._g(
      _vm._b(
        {
          attrs: {
            title: "风险设备详情",
            "close-on-click-modal": false,
            top: "80px",
            "append-to-body": "",
          },
        },
        "el-dialog",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _c(
        "el-form",
        { attrs: { "label-width": "120px" } },
        [
          _c("el-form-item", { attrs: { label: "渠道+UID", prop: "level" } }, [
            _c("div", { staticClass: "info" }, [
              _vm._v(" 渠道：" + _vm._s(_vm.riskDevice.appid)),
            ]),
            _c("div", { staticClass: "info" }, [
              _vm._v("UID：" + _vm._s(_vm.riskDevice.uid)),
            ]),
          ]),
          _c("el-form-item", { attrs: { label: "Mac 地址", prop: "mac" } }, [
            _c("div", { staticClass: "info" }, [
              _vm._v(_vm._s(_vm.riskDevice.mac)),
            ]),
          ]),
          _c(
            "el-form-item",
            { attrs: { label: "AndroidID", prop: "androidID" } },
            [
              _c("div", { staticClass: "info" }, [
                _vm._v(_vm._s(_vm.riskDevice.androidId)),
              ]),
            ]
          ),
          _c("el-form-item", { attrs: { label: "IDFA", prop: "idfa" } }, [
            _c("div", { staticClass: "info" }, [
              _vm._v(_vm._s(_vm.riskDevice.idfa)),
            ]),
          ]),
          _c("el-form-item", { attrs: { label: "风险等级", prop: "level" } }, [
            _c("div", { staticClass: "level-wrapper" }, [
              _c("div", { staticClass: "level" }, [
                _vm._v(_vm._s(_vm.risks.level)),
              ]),
              _c("div", { staticClass: "desc" }, [
                _vm._v(_vm._s(_vm.risks.desc)),
              ]),
            ]),
          ]),
          _c("el-form-item", { attrs: { label: "备注", prop: "remark" } }, [
            _c("div", { staticClass: "info" }, [
              _vm._v(_vm._s(_vm.riskDevice.remark)),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }